import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { debounceTime, filter } from 'rxjs/operators';
import { TipoNCNDService } from 'src/app/services/tipo-ncnd.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ModalSeleccionDocumentoFTComponent } from './../../common/modal-seleccion-documento-ft/modal-seleccion-documento.-ftcomponent';
import * as _ from 'lodash';
import { DatesService } from 'src/app/shared/services/dates.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-nota-credito-cabecera',
  templateUrl: './nota-credito-cabecera.component.html',
  styleUrls: ['./nota-credito-cabecera.component.scss'],
  providers: [SecurityService, DatePipe],
})
export class NotaCreditoCabeceraFTComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionDocumentoFTComponent, { static: true }) modalSeleccionarDocumento: ModalSeleccionDocumentoFTComponent;

  // I/O
  @Output() onCabeceraChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('datePicker', { static: true }) datePickerFechaDoc: MDBDatePickerComponent;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  optionsDoctoReferencia: Array<any> = [];
  optionsTipoNotaCredito: Array<any> = [];
  dataCabecera: any = null;
  detalleDocumentoOriginal: any;

  // Form
  formHeader: FormGroup;

  readonly APLICACION_INMEDIATA: Number = 1;
  readonly APLICACION_GUARDAR: Number = 2;

  readonly TIPO_CORRECCION_MONTO_DEVOLUCION: Number = 10;
  readonly TIPO_CORRECCION_MONTO_CORRECCION: Number = 20;

  // Utils
  private log: any;
  OcultarStock: boolean = true;

  constructor(
    private accesolocalstorage: SecurityService,
    private tipoDTEService: TipoDTEService,
    private tipoNCNDService: TipoNCNDService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private datePipe: DatePipe
  ) {
    this.log = this.clog.log('NOTA-CREDITO-CABECERA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.loadComboDoctoRef();

    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    this.formHeader = this.fb.group({
      doctoReferencia: [null, [Validators.required, Validators.min(1)]],
      nroDoc: [null, [Validators.required]],
      tipoNotaCredito: [null, [Validators.required, Validators.min(1)]],
      rebajaStock: [true],
      tipoAplicacion: [this.APLICACION_INMEDIATA],
      tipoCorreccionMonto: [this.TIPO_CORRECCION_MONTO_DEVOLUCION],
      fechaDocumento: [null, [Validators.required]],
      // sucursal: [null, [Validators.required]],
      // vendedor: [null, [Validators.required]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader
      .get('nroDoc')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroDoc: string) => {
        if (!nroDoc) return;
        this.searchByNroDoc();
      });

    this.formHeader.get('doctoReferencia').valueChanges.subscribe((doctoReferencia: string) => {
      if (!doctoReferencia) return;

      if (Number(doctoReferencia) == 46) {
        this.OcultarStock = false;
        this.formHeader.get('rebajaStock').setValue(false);
        this.formHeader.get('tipoAplicacion').setValue(this.APLICACION_INMEDIATA);
      } else {
        this.OcultarStock = true;
        this.formHeader.get('rebajaStock').setValue(true);
      }
      this.searchByNroDoc();
    });

    this.formHeader.get('tipoNotaCredito').valueChanges.subscribe((tipoNotaCredito: Number) => {
      if (this.dataCabecera) this.dataCabecera.detalleDocumento = _.cloneDeep(this.detalleDocumentoOriginal);
      if (tipoNotaCredito) this.handleChangeTipoNotaCredito(tipoNotaCredito);
      this.emitCambioDataCabecera();
    });

    this.formHeader.get('tipoCorreccionMonto').valueChanges.subscribe((tipoCorreccionMonto: Number) => {
      // this.log('tipoCorreccionMonto change', tipoCorreccionMonto)
      this.emitCambioDataCabecera();
    });
  }

  get doctoReferencia() {
    if (this.formHeader && this.formHeader.get('doctoReferencia')) return this.formHeader.get('doctoReferencia').value;
    return 0;
  }

  searchByNroDoc() {
    const folio = this.formHeader.get('nroDoc').value;
    const tipo_dte_codigo = this.formHeader.get('doctoReferencia').value ? this.formHeader.get('doctoReferencia').value : 0;
    if (folio) this.modalSeleccionarDocumento.searchByNroDoc(Number(folio), Number(tipo_dte_codigo)); // this.formHeader.get("doctoReferencia").value)
  }

  handleChangeTipoNotaCredito(tipoNotaCredito) {
    if (tipoNotaCredito === 1) {
      this.formHeader.get('rebajaStock').disable();
      this.formHeader.get('tipoAplicacion').disable();
    } else {
      this.formHeader.get('rebajaStock').enable();
      this.formHeader.get('tipoAplicacion').enable();
    }
  }
  get desactivaRebajaStockAndAplicacion() {
    if (Number(this.formHeader.get('tipoNotaCredito').value) === 1) return true;
    return false;
  }

  get showOpcionesCorreccionMonto() {
    if (Number(this.formHeader.get('tipoNotaCredito').value) === 2) return true;
    return false;
  }

  private loadComboDoctoRef() {
    // Tipos documentos
    this.tipoDTEService.GetByTipoDte(1, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsDoctoReferencia = registros.filter((x) => x.codigo == 46).map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
      this.setDefaultDoctoReferencia();
    });
  }

  setDefaultDoctoReferencia() {
    const facturaOption = this.optionsDoctoReferencia.filter((p) => p.codigo === 46);
    if (facturaOption && facturaOption.length > 0) this.formHeader.get('doctoReferencia').setValue(facturaOption[0].codigo);
  }

  abrirModalSeleccionDocumento() {
    this.modalSeleccionarDocumento.show();
  }

  onDocumentoSeleccionado({ data }) {
    this.dataCabecera = this.cleanDataCabecera(data); //.cabecera
    this.dataCabecera.cabecera.additionalInfo = {};
    this.dataCabecera.cabecera.additionalInfo.cliente_proveedor_rut_completo = this.rutService.AgregarDV(this.dataCabecera.cabecera.cliente_proveedor_rut);
    this.formHeader.get('nroDoc').setValue(data.cabecera.folio);

    if (this.datesService.CurrentDateToShortTimeString() > this.datePipe.transform(data.cabecera.fecha_emision, 'yyyy-MM-dd')) {
      this.formHeader.get('fechaDocumento').setValue(this.datesService.CurrentDateToShortTimeString());
    } else {
      this.formHeader.get('fechaDocumento').setValue(this.datePipe.transform(data.cabecera.fecha_emision, 'yyyy-MM-dd'));
    }

    this.setDetallesOriginales(data.detalleDocumento);
    this.loadComboTipoNotaCredito();
    this.emitCambioDataCabecera();
  }

  setDetallesOriginales(detalleDocumento) {
    this.detalleDocumentoOriginal = _.cloneDeep(detalleDocumento);
    this.detalleDocumentoOriginal.map((p) => {
      delete p.__typename;

      // parche para que tome la validación en el detalle
      if (p.motivo_devolucion_especifico_codigo === 0) p.motivo_devolucion_especifico_codigo = null;

      if (p.atributos) {
        p.atributos.map((attr) => {
          delete attr.__typename;
        });
      }
    });
  }

  private cleanDataCabecera(_dataCabecera) {
    delete _dataCabecera.cabecera.cliente_proveedor_rut_string;

    delete _dataCabecera.cabecera.__typename;

    _dataCabecera.descuentosGlobales.map((p) => {
      delete p.__typename;
    });

    _dataCabecera.detalleDocumento.map((p) => {
      delete p.__typename;

      // parche para que tome la validación en el detalle
      if (p.motivo_devolucion_especifico_codigo === 0) p.motivo_devolucion_especifico_codigo = null;

      if (p.atributos) {
        p.atributos.map((attr) => {
          delete attr.__typename;
        });
      }
    });
    return _dataCabecera;
  }

  addAdditionInfo() {
    this.log('addAdditionInfo');
    const tipoNotaCredito = Number(this.formHeader.get('tipoNotaCredito').value);
    const tipoCorreccionMonto = Number(this.formHeader.get('tipoCorreccionMonto').value);

    const additionalHeaderInfo = {
      tipoNotaCredito,
      tipoCorreccionMonto,
      esCorreccionDeMonto: tipoCorreccionMonto === this.TIPO_CORRECCION_MONTO_CORRECCION,
      denyEditCantidad: true,
      denyEditMotivo: true,
      showGlosa: false,
      showTabla: false,
      showTotales: false,
      showMotivoGeneral: false,
      showMotivoEspecifico: false,
      showProductoLibre: false,
      showSkuAnulacion: false,
    };

    switch (tipoNotaCredito) {
      case 1:
        {
          this.log('ADMINISTRATIVA');
          additionalHeaderInfo.showGlosa = true;
          additionalHeaderInfo.showMotivoGeneral = true;
        }
        break;
      case 2:
        {
          this.log('PARCIAL');
          // Devolución
          if (tipoCorreccionMonto === this.TIPO_CORRECCION_MONTO_DEVOLUCION) {
            additionalHeaderInfo.denyEditCantidad = false;
            additionalHeaderInfo.denyEditMotivo = false;
            additionalHeaderInfo.showTabla = true;
            additionalHeaderInfo.showTotales = true;
            additionalHeaderInfo.showMotivoGeneral = true;
            additionalHeaderInfo.showMotivoEspecifico = true;
          } else {
            // Corrección de monto
            additionalHeaderInfo.showMotivoGeneral = true;
            additionalHeaderInfo.showProductoLibre = true;
            additionalHeaderInfo.showTotales = true;
          }
        }
        break;
      case 3:
        {
          this.log('ANULACION TOTAL');
          additionalHeaderInfo.denyEditMotivo = true;
          additionalHeaderInfo.showTabla = true;
          additionalHeaderInfo.showTotales = true;
          additionalHeaderInfo.showMotivoGeneral = true;
          additionalHeaderInfo.showSkuAnulacion = true;
        }
        break;
      default:
        break;
    }
    this.dataCabecera.cabecera.additionalInfo = { ...this.dataCabecera.cabecera.additionalInfo, ...additionalHeaderInfo };

    this.log('addAdditionInfo dataCabecera.detalleDocumento', this.dataCabecera.detalleDocumento);
    this.dataCabecera.detalleDocumento.forEach((documento, index) => {
      documento.additionalInfo = {
        editing: false,
        cantidad: documento.cantidad,
        id: `cantidad_${documento.nro_linea}`,
        index: index,
        checked: false,
      };
      if (documento.seleccion) {
        documento.additionalInfo.checked = true;
      } else {
        if (this.dataCabecera.cabecera.additionalInfo.tipoNotaCredito === 2) documento.cantidad = 0;
        documento.motivo_devolucion_especifico_codigo = 0;
      }
    });
  }

  emitCambioDataCabecera() {
    // this.log('emitChangeHeader', this.dataCabecera, this.formHeader.get("tipoNotaCredito").value, !this.dataCabecera || !this.formHeader.get("tipoNotaCredito").value)
    if (!this.dataCabecera || !this.formHeader.get('tipoNotaCredito').value) return;

    this.addAdditionInfo();

    // this.log('emitir', this.dataCabecera)
    this.onCabeceraChange.emit(this.dataCabecera);
  }

  private loadComboTipoNotaCredito() {
    // Tipos documentos
    const inputParams = {
      // tipo_ncnd_codigo: number
      tipo_filtro_ncnd: 1,
      rut_emisor: this.rutEmpresa,
      tipo_dte_codigo: this.formHeader.get('doctoReferencia').value,
      folio: this.formHeader.get('nroDoc').value,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    // this.tipoNCNDService.GetSegunTipoNCND(this.dataCabecera.cabecera.tipo_ncnd_codigo, 1, ({ respuesta }) => {
    this.tipoNCNDService.GetSegunTipoNCND(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoNotaCredito = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));

      if (this.formHeader.get('doctoReferencia').value == 46) {
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoNotaCredito'), this.optionsTipoNotaCredito);
      }
    });
  }

  onNotFoundDocumento() {
    this.dataCabecera = null;

    this.optionsTipoNotaCredito = [];

    this.onCabeceraChange.emit(this.dataCabecera);
  }

  getHeaderData() {
    return {
      ...this.formHeader.value,
      dataCabecera: this.dataCabecera,
    };
  }

  validate() {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    return this.formHeader.valid;
  }

  public cleanData() {
    this.optionsTipoNotaCredito = [];
    this.dataCabecera = null;

    this.datePickerFechaDoc.clearDate();

    // Form
    this.formHeader.reset();
    this.formHeader.markAsUntouched();
    this.formHeader.markAsPristine();

    this.formHeader.get('doctoReferencia').setValue(null);
    this.formHeader.get('fechaDocumento').setValue(null);
    this.formHeader.get('nroDoc').setValue(null);
    this.formHeader.get('tipoNotaCredito').setValue(null);
    this.formHeader.get('rebajaStock').setValue(true);
    this.formHeader.get('tipoAplicacion').setValue(this.APLICACION_INMEDIATA);
    this.formHeader.get('tipoCorreccionMonto').setValue(this.TIPO_CORRECCION_MONTO_DEVOLUCION);
    setTimeout(() => {
      this.formHeader.get('fechaDocumento').setValue(null);
    }, 500);

    setTimeout(() => {
      this.formHeader.get('fechaDocumento').setValue(null);
    }, 1000);

    this.setDefaultDoctoReferencia();
    this.modalSeleccionarDocumento.clearLast();
  }

  updateDetalleDocumento(registros) {
    this.log('update detalle documentos', registros);
    if (this.dataCabecera) this.dataCabecera.detalleDocumento = _.cloneDeep(registros);
    this.emitCambioDataCabecera();
  }
}
